import { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '__components/Inputs/TextInput';
import { usePreserveCaretPosition } from 'hooks/usePreserveCaretPosition';

export const VariableNameInput: FC<{
  value: string;
  onChange: (value: string) => string;
  label: string;
  error: boolean;
  validate?: any;
  disabled?: boolean;
}> = ({ value, label, onChange, error, validate, disabled }) => {
  const { t } = useTranslation();

  const [innerValue, setInnerValue] = useState<string>(value);

  const handleBlur = () => {
    const changed = onChange(innerValue);
    setInnerValue(changed);
  };

  const handleChange = (value: string) => {
    const croppedName = value.toLowerCase().replaceAll(' ', '_');
    setInnerValue(croppedName);
  };

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  const inputRef = usePreserveCaretPosition(innerValue);

  return (
    <TextInput
      inputRef={inputRef}
      value={innerValue}
      label={label}
      placeholder={t('Enter Name')}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      validate={validate}
      disabled={disabled}
    />
  );
};
